module.exports = __webpack_public_path__ + "static/img/fav_180-01.2b697c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fav_180-01.png
// module id = 2989
// module chunks = 1